/**
 * 【KnowledgeSuggestion コンポーネント】: ナレッジ生成サジェスチョン
 * 【機能概要】: 2往復後にナレッジ生成を提案するUI
 * 【設計方針】: ChatMessageの実装パーツを参考にした統一されたデザイン
 * 🟢 信頼性レベル: TDD Red→Green サイクルによる確実な実装
 */

import LightbulbIcon from "@mui/icons-material/Lightbulb";
import type React from "react";
import Button from "../../ui/button";
import styles from "../styles.module.scss";

interface KnowledgeSuggestionProps {
  onAccept: () => void;
  onReject: () => void;
  isLoading?: boolean;
  isGenerating?: boolean;
}

const KnowledgeSuggestion: React.FC<KnowledgeSuggestionProps> = ({
  onAccept,
  onReject,
  isLoading = false,
  isGenerating = false,
}) => {
  // 生成中の表示
  if (isGenerating) {
    return (
      <div className={styles["knowledgeSuggestionCard"]} data-testid="knowledge-suggestion">
        <div className={styles["suggestionContent"]}>
          <div className={styles["suggestionHeader"]}>
            <LightbulbIcon className={styles["lightbulbIcon"] ?? ""} />
            <span className={styles["suggestionTitle"]}>ナレッジ生成中...</span>
          </div>
          <p className={styles["suggestionText"]}>
            会話内容を分析してナレッジを生成しています。しばらくお待ちください。
          </p>
        </div>
      </div>
    );
  }

  // 初期提案表示
  return (
    <div className={styles["knowledgeSuggestionCard"]} data-testid="knowledge-suggestion">
      <div className={styles["suggestionContent"]}>
        <div className={styles["suggestionHeader"]}>
          <LightbulbIcon className={styles["lightbulbIcon"] ?? ""} />
          <span className={styles["suggestionTitle"]}>ナレッジを生成しますか？</span>
        </div>
        <p className={styles["suggestionText"]}>
          これまでの会話を元に、ナレッジを自動生成できます。
        </p>
      </div>

      <div className={styles["suggestionActions"]}>
        <button
          className={styles["suggestionRejectButton"]}
          onClick={onReject}
          disabled={isLoading}
          data-testid="knowledge-suggestion-no"
        >
          いいえ
        </button>
        <Button
          label="はい"
          styleType="white-small"
          onClick={onAccept}
          disabled={isLoading}
          data-testid="knowledge-suggestion-yes"
        />
      </div>
    </div>
  );
};

export default KnowledgeSuggestion;
